import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 90%;
`;

export const ContentInfor = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    padding: 4px 0px;
    border-bottom: 1px dashed ${(props) => props.theme.colors.gray.gray_100};
`;

export const ContentPayment = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    &.content-color{
        border: 1px dashed ${(props) => props.theme.colors.gray.gray_100};
        padding: 4px 8px;
        border-radius: 4px;
    }
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 400px;
    overflow-y: auto;

    &::-webkit-scrollbar { 
        display: none;
    }
`;

export const ButtonClose = styled.button`
    display: flex;
    background-color: transparent;
    color: ${(props) => props.theme.colors.gray.gray_500};
    &:hover{
        color: ${(props) => props.theme.colors.primary};
    }
`;

export const ButtonPayment = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    
    width: 100%;
    height: 50px;
    padding: 10px;
    border-radius: 4px;
    
    &.active{
        font-weight: 500;
        border-left: 2px solid ${(props) => props.theme.colors.primary};
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
`;

export const HeaderValues = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Title = styled.p`
    display: flex;
    flex-direction: column;
    font-size: 32px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.gray.gray_800};

    span{
        color: ${(props) => props.theme.colors.gray.gray_500};
        font-size: 14px;
        font-weight: 400;
    }
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    input{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
        padding: 10px;
        width: 100%;
    }
`;

export const Label = styled.label`

    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const listButtonPay = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;

    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const Infor = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;

    color: ${(props) => props.theme.colors.gray.gray_500};
    span{
        color: ${(props) => props.theme.colors.gray.gray_800};
    }
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Status = styled.div`
    background-color: oklch(96.2% 0.044 156.743);
    color: ${(props) => props.theme.colors.success};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    padding: 2px 4px;
    &.status-30{
        border-radius: 30px;
        height: 64px;
        width: 64px;
    }
`;

export const Text = styled.p`
    &.text-p{
        font-size: 14px;
    }
`;